import { http } from '../plugins/http'
import type { AxiosResponse } from 'axios'

import type Affiliate from '@/types/Affiliate'
import type PaginatedResponse from '@/types/PaginatedResponse'
import type DataResponse from '@/types/DataResponse'
import ModelService from '@/contracts/ModelService'
import type MessageResponse from '@/types/MessageResponse'
import type Order from '@/types/Order'

export default class AffiliateService extends ModelService<Affiliate> {
  async index(page: number, filters: string, per_page: number | undefined = 10): Promise<AxiosResponse<PaginatedResponse<Affiliate>>> {
    return await http.get<PaginatedResponse<Affiliate>>(`/api/v1/office/affiliates?page=${page}&${filters}&per_page=${per_page}`)
  }

  async show(id: string) {
    return await http.get<DataResponse<Affiliate>>(`/api/v1/office/affiliates/${id}`)
  }

  async store(model: Affiliate) {
    return await http.post<DataResponse<Affiliate>>(`/api/v1/office/affiliates`, model)
  }

  async update(id: string, model: Affiliate) {
    return await http.put<DataResponse<Affiliate>>(`/api/v1/office/affiliates/${id}`, model)
  }

  async destroy(model: Affiliate) {
    return await http.delete(`/api/v1/office/affiliates/${model.id}`)
  }

  async toggle(model: Affiliate, event_id: string): Promise<AxiosResponse<MessageResponse>> {
    return await http.patch(`/api/v1/office/events/${event_id}/affiliates/${model.id}`)
  }

  async accreditations(page: number, filters: string, per_page: number | undefined = 10, event_id: string): Promise<AxiosResponse<PaginatedResponse<Affiliate>>> {
    return await http.get(`/api/v1/office/events/${event_id}/affiliates?page=${page}&${filters}&per_page=${per_page}`)
  }

  async sales(page: number, filters: string, per_page: number | undefined = 10): Promise<AxiosResponse<PaginatedResponse<Order>>> {
    return await http.get(`/api/v1/office/affiliates/sales?page=${page}&${filters}&per_page=${per_page}`)
  }

  async salesReport(filters: string, selected: Record<string, string>): Promise<AxiosResponse<BlobPart>> {
    filters = (filters !== '') ? `?${filters}` : ''

    return await http.post(`/api/v1/office/affiliates/sales/${filters}`,
      { selected },
      {
        headers: {
          Accept: 'application/csv',
        },
      },
    )
  }
}
